import './index';
window.Page = window.Page || {};
let Page = window.Page;

$('.amenity-button').on('click', function (e) {
    e.preventDefault();
});

$('#save_amenity_button').on('click', function (e) {
    e.preventDefault();
    Page.filters.amenityIds = [];
    $.each($('.amenity-button.filter-selected'), function () {
        Page.filters.amenityIds.push($(this).attr('id'));
    });
    loadSearchResults(Page.currentPageNum);
});
//.price-range-clear-button
$('#clear_amenity_button').on('click', function (e) {
    e.preventDefault();
    Page.filters.amenityIds = [];
    $.each($('.amenity-button'), function () {
        $(this).removeClass('filter-selected');
    });
    loadSearchResults(Page.currentPageNum);
});
$('#price_range_save_button').on('click', function (evt) {
    evt.preventDefault();
    loadSearchResults(Page.currentPageNum);
});


$('#meeting_room_capacity_select li').on('click', function () {
    $('#meeting_room_capacity').val($(this).attr('rel'));
    Page.filters.maxMeetingRoomCapacity = $(this).attr('rel');
});








